import { render } from "./SSOAuth.vue?vue&type=template&id=3c2dec36"
import script from "./SSOAuth.vue?vue&type=script&lang=js"
export * from "./SSOAuth.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__